/** @jsxImportSource @emotion/react */
import { FC } from 'react';
import useStyle from './HomepageHero2.style';
import Imgix from 'react-imgix';
import { Button, H1 } from '@shared/react-ui-core';
import { cx } from '@emotion/css';

export type HomepageHeroProps = {
  title?: string;
  subtitle?: string;
  image?: {
    url: string;
    alt: string;
  };
  mobileImage?: {
    url: string;
    alt: string;
  };
  variant?: 'lifestyle' | 'equipment' | 'tan';
};

const images = {
  lifestyle: {
    url: 'https://www.datocms-assets.com/10154/1687191456-alarm-display-on-side-table.png',
    alt: 'alarm display on side table',
  },
  equipment: {
    url: 'https://www.datocms-assets.com/10154/1692907799-mask-group-20.png',
    alt: 'Cove Smart Home Security',
  },
  tan: {
    url: 'https://www.datocms-assets.com/10154/1692907799-mask-group-20.png',
    alt: 'Cove Smart Home Security',
  },
};

const mobileImages = {
  lifestyle: {
    url: 'https://www.datocms-assets.com/10154/1687191456-alarm-display-on-side-table.png',
    alt: 'alarm display on side table',
  },
  equipment: {
    url: 'https://www.datocms-assets.com/10154/1692721556-mask-group-19.png',
    alt: 'Cove Smart Home Security',
  },
  tan: {
    url: 'https://www.datocms-assets.com/10154/1692714551-mask-group-17.png',
    alt: 'Cove Smart Home Security',
  },
};

const HomepageHero2: FC<HomepageHeroProps> = ({
  title = 'New technology. Better protection.',
  subtitle = 'Our most advanced home security system yet.',
  variant = 'lifestyle',
  image = images[variant],
  mobileImage = mobileImages[variant],
}) => {
  const s = useStyle();

  return (
    <section
      css={s.hero}
      className={cx({
        'lifestyle-variant': variant === 'lifestyle',
        'equipment-variant': variant === 'equipment',
        'tan-variant': variant === 'tan',
      })}
    >
      <div className="images">
        <Imgix
          src={mobileImage.url}
          sizes="100%"
          className="mobile"
          htmlAttributes={{ loading: 'lazy', alt: mobileImage.alt }}
        />
        <Imgix
          className="desktop"
          src={image.url}
          width={807}
          htmlAttributes={{ loading: 'lazy', alt: image.alt }}
        />
      </div>
      <div className="content">
        <H1 css={s.headerHeading} seoH1>
          {title}
        </H1>
        <p>{subtitle}</p>
        <CTAButton className="ctaButton" />
      </div>
      <div className="actions">
        <CTAButton className="ctaButton" />
        <span>
          Rated #1 DIY Home Security System of 2024 by Consumer Advocates
        </span>
      </div>
    </section>
  );
};

const CTAButton = ({ className }: { className: string }) => {
  const s = useStyle();

  return (
    <div className={className} css={s.cta}>
      <Button
        color="purple"
        size="large"
        style="container"
        cypressId="link-to-quiz-1"
        data-cypress-selector="link-to-quiz-1"
        id="ctaSectionHero"
        href={`/quiz${
          (typeof window !== `undefined` && window.location.search) || ''
        }`}
      >
        See What it Costs
      </Button>
      <p>Takes less than 1 minute</p>
    </div>
  );
};

export default HomepageHero2;
